import { createSelector } from "reselect";

const messagesState = (state) => state.messages;

export const selectNextMessage = createSelector(messagesState, (state) => state.items.length ? state.items[0] : {});
